import { List } from "../Components/index.js";

export default [
    {
        path: "/admin/property/setting/group",
        component: List,
        name: "admin.property.setting",
        meta: {
            requiresAuth: true,
        },
    },
];
